import { PropsWithChildren } from 'react';

import type { AiAssistantSocket } from '@mint-sdk/api-ai-assistant';

import { SocketProvider } from './SocketProvider.jsx';
import { TextChatProvider } from './TextChatProvider.jsx';
import { VoiceChatProvider } from './VoiceChatProvider.jsx';

type Props = {
  chatId: string;
  voiceEnabled?: boolean;
  voiceModeParam?: boolean;
  onLeaveVoiceMode?: () => void;
  target?: AiAssistantSocket.ChatTarget;
};

export const AiChatProviders = ({
  children,
  chatId,
  voiceEnabled = true,
  voiceModeParam = false,
  onLeaveVoiceMode,
  target,
}: PropsWithChildren<Props>) => (
  <SocketProvider chatId={chatId}>
    <TextChatProvider target={target}>
      <VoiceChatProvider
        enabled={voiceEnabled}
        voiceModeParam={voiceModeParam}
        onLeaveVoiceMode={onLeaveVoiceMode}
      >
        {children}
      </VoiceChatProvider>
    </TextChatProvider>
  </SocketProvider>
);
